<template>
    <div class="sugProjectsList">
        <div class="projectsHead">
            <div class="projectsLogo">推荐项目</div>
        </div>
        <ul>
            <li v-bind:key="index" v-for="(item, index) in sugProjects">
                <a :href="item.url" target="_Blank">
                    <img :src="item.logo" :title="item.title" />
                </a>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    data() {
        return {
            sugProjects: [
                {
                    url: 'https://github.com/PaddlePaddle',
                    logo: require('../../images/paddle.svg'),
                    title: '飞桨Paddle'
                },
                {
                    url: 'https://github.com/ApolloAuto',
                    logo: require('../../images/apollo.svg'),
                    title: 'Apollo'
                },
                {
                    url: 'https://github.com/xuperchain/xuperchain',
                    logo: require('../../images/XuperChain.svg'),
                    title: 'XuperChain'
                },
                {
                    url: 'https://github.com/apache/incubator-echarts',
                    logo: require('../../images/ECharts.svg'),
                    title: 'ECharts'
                },
                {
                    url: 'https://github.com/apache/incubator-doris',
                    logo: require('../../images/Doris.svg'),
                    title: 'Doris'
                },
                {
                    url: 'https://github.com/apache/incubator-brpc',
                    logo: require('../../images/brpc.svg'),
                    title: 'brpc'
                },
                {
                    url: 'https://github.com/baidu/bfe',
                    logo: require('../../images/BFE.svg'),
                    title: 'BFE'
                },
                {
                    url: 'https://github.com/baetyl/baetyl',
                    logo: require('../../images/Baetyl.svg'),
                    title: 'Baetyl'
                },
                {
                    url: 'https://github.com/elasticdeeplearning/edl',
                    logo: require('../../images/EDL.svg'),
                    title: 'EDL'
                },
                {
                    url: 'https://github.com/apache/incubator-teaclave',
                    logo: require('../../images/Teaclave.svg'),
                    title: 'Teaclave'
                },
                {
                    url: 'https://github.com/hugegraph/hugegraph',
                    logo: require('../../images/HugeGraph.svg'),
                    title: 'HugeGraph'
                },
                {
                    url: 'https://github.com/baidu/amis',
                    logo: require('../../images/amis.svg'),
                    title: 'amis'
                },
                {
                    url: 'https://github.com/baidu/San',
                    logo: require('../../images/san.svg'),
                    title: 'san'
                }
            ]
        };
    }
}
</script>
<style lang="less">
.sugProjectsList{
    max-width: 1320px;
    margin: 30px auto;
    overflow: hidden;
    .projectsHead{
        width: 100%;
        height: 36px;
        margin-bottom: 16px;
        .projectsLogo{
            color: #043483;
            float: left;
            height: 26px;
            line-height: 26px;
            border: 1px solid #043483;
            border-radius: 18px;
            padding: 0 20px;
        }
    }

    ul{
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        grid-gap: 12px;
        li{
            border: 1px solid #eee;
            list-style-type: none;
            border-radius: 8px;
            a{
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    margin: auto;
                }
            }
        }
        li:hover{
            border: 1px solid #1595DC;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/common/sug-projects-list/index.vue